import { render } from "./UploadCustomerDoc.vue?vue&type=template&id=4c699575&scoped=true&ts=true"
import script from "./UploadCustomerDoc.vue?vue&type=script&lang=ts"
export * from "./UploadCustomerDoc.vue?vue&type=script&lang=ts"

import "./UploadCustomerDoc.vue?vue&type=style&index=0&id=4c699575&scoped=true&lang=css"
import "./UploadCustomerDoc.vue?vue&type=style&index=1&id=4c699575&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c699575"]])

export default __exports__